import React, { useState } from 'react';
import { useSelector } from 'store';
import { useDispatch } from 'react-redux';
import { communityActions } from 'store/community';
import { useRouter } from 'next/router';
import styled from 'styled-components';

interface IProps {
  selected: string;
}

const CommunitySideMenu: React.FC<IProps> = ({ selected }: IProps) => {
  const my = useSelector(state => state.accounts.user);
  const user = useSelector(state => state.community.community_select_user);
  const regions = useSelector(state => state.space.regions).results;

  const dispatch = useDispatch();
  const router = useRouter();

  const selectedClass = value => {
    return selected === value ? 'selected' : '';
  };

  const clickRemoveUser = () => {
    dispatch(communityActions.setCommunitySelectUser(null));
  };

  const clickRouteUser = id => {
    router.push(`/community/user/${id}`);
  };

  const clickRoute = url => {
    router.push(url);
  };

  return (
    <aside className="selected">
      <h2>커뮤니티</h2>
      <div style={{ border: 0, padding: 0 }}>
        <SideMenuWrapper>
          <Menu className={selectedClass('최신글')}>
            <Anchor
              onClick={() => clickRoute('/community/new_post')}
              style={{ cursor: 'pointer' }}
            >
              최신글
            </Anchor>
          </Menu>
          <Menu className={selectedClass('공지사항')}>
            <Anchor
              onClick={() => clickRoute('/community/notice')}
              style={{ cursor: 'pointer' }}
            >
              공지사항
            </Anchor>
          </Menu>
          <Menu className={selectedClass('이벤트 & 모임')}>
            <Anchor
              onClick={() => clickRoute('/community/event')}
              style={{ cursor: 'pointer' }}
            >
              이벤트 &amp; 모임
            </Anchor>
          </Menu>
          <Menu className={selectedClass('owner')}>
            <Anchor
              onClick={() => clickRoute(`/community/user/${my.id}`)}
              style={{ cursor: 'pointer' }}
            >
              내가 작성한 글
            </Anchor>
          </Menu>
          {regions.length > 0 &&
            regions.map(region => (
              <Menu className={selectedClass(region.name)} key={region.id}>
                <Anchor
                  onClick={() => clickRoute(`/community/cluster/${region.id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  {region.name}
                </Anchor>
              </Menu>
            ))}
          {user !== null && (
            <Menu className={selectedClass('user')}>
              <Anchor
                onClick={() => clickRouteUser(user.id)}
                style={{ cursor: 'pointer' }}
              >
                {user.profile.display_name}
              </Anchor>
              <button
                type="button"
                className="btn-delete"
                onClick={clickRemoveUser}
              >
                <span>삭제</span>
              </button>
            </Menu>
          )}
        </SideMenuWrapper>
      </div>
    </aside>
  );
};

const SideMenuWrapper = styled.ul`
  @media screen and (max-width: 786px) {
    display: flex;
    overflow-x: scroll;
    padding-bottom: 16px;
  }
`;

const Menu = styled.li`
  @media screen and (max-width: 786px) {
    flex: 1 0;
    padding: 4px 12px !important;
    margin-right: 12px;
    justify-content: center;
    text-align: center;
    border-radius: 20px;
    font-size: 14px;
    font-weight: bold;
    background-color: ${props =>
      props.className === 'selected' ? '#111' : 'unset'};
    color: ${props => (props.className === 'selected' ? 'white' : '#111')};
    white-space: nowrap;
  }
`;

const Anchor = styled.a`
  @media screen and (max-width: 786px) {
    color: inherit;
  }
`;

export default CommunitySideMenu;
